// extracted by mini-css-extract-plugin
export default {"contract_id":"styles_contract_id__aWxQ8","tag":"styles_tag__CMkvq","text_wrapper":"styles_text_wrapper__EsO8P","itemDetailImage":"styles_itemDetailImage__68NAg"};